var _path, _path2, _path3, _path4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLikeDislike(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7287 47.3958H16.2079C15.3954 47.3958 13.7704 47.1457 12.8329 46.229L9.29122 43.5L11.2079 41.0207L14.8954 43.8751C15.1662 44.1043 15.7287 44.2708 16.2079 44.2708H20.7287C21.4995 44.2708 22.3746 43.625 22.5412 42.9583L25.4371 34.1458C25.5204 33.9375 25.5829 33.625 25.4371 33.3959C25.3121 33.2084 25.0204 33.1042 24.6662 33.1042H19.8954C19.0829 33.1042 18.3329 32.7501 17.7912 32.1459C17.2496 31.5209 17.0204 30.7291 17.1454 29.8749L17.7495 26.0416C17.8329 25.6875 17.5829 25.2499 17.2496 25.1457C16.9787 25.0415 16.5204 25.2292 16.4162 25.3751L11.5204 32.6459L8.91622 30.8957L13.7912 23.6249C14.7079 22.2499 16.7079 21.625 18.2496 22.2084C20.0204 22.7917 21.1871 24.7917 20.7704 26.625L20.2496 29.9583H24.6037C25.9995 29.9583 27.2079 30.5417 27.9371 31.5834C28.6454 32.5834 28.7912 33.8958 28.3329 35.1458L25.4787 43.8125C25.0621 45.7709 22.937 47.3958 20.7287 47.3958Z",
    fill: "url(#paint0_linear_505_6637)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.74951 46.0833H6.56201C3.31201 46.0833 2.62451 44.0001 2.62451 42.2501V30.5835C2.62451 28.8335 3.31201 26.7499 6.56201 26.7499H7.74951C10.9995 26.7499 11.687 28.8335 11.687 30.5835V42.2501C11.687 44.0001 10.9995 46.0833 7.74951 46.0833ZM5.81201 42.8749C5.83284 42.8749 6.04117 42.9583 6.54117 42.9583H7.72867C8.27034 42.9583 8.45784 42.8749 8.49951 42.8541C8.49951 42.8332 8.56201 42.6876 8.56201 42.2501V30.5835C8.56201 30.146 8.49951 29.9792 8.47867 29.9584C8.47867 30 8.27034 29.8749 7.74951 29.8749H6.56201C6.02034 29.8749 5.83284 29.9584 5.79117 29.9792C5.79117 30 5.72867 30.146 5.72867 30.5835V42.2501C5.72867 42.6876 5.79118 42.8541 5.81201 42.8749Z",
    fill: "url(#paint1_linear_505_6637)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9379 27.9999C32.5212 27.9999 32.1046 27.9374 31.7087 27.7916C29.9379 27.2083 28.7712 25.2083 29.1879 23.3749L29.7087 20.0416H25.3546C23.9587 20.0416 22.7504 19.4583 22.0212 18.4166C21.3129 17.4166 21.1671 16.1042 21.6254 14.8542L24.4796 6.18743C24.9587 4.2291 27.1046 2.60416 29.2921 2.60416H33.8129C34.6254 2.60416 36.2504 2.85428 37.1879 3.77095L40.7296 6.49998L38.8129 8.97928L35.1254 6.12487C34.8546 5.8957 34.2921 5.72916 33.8129 5.72916H29.2921C28.5212 5.72916 27.6462 6.375 27.4796 7.04167L24.5837 15.8541C24.5004 16.0625 24.4379 16.3749 24.5837 16.6041C24.7087 16.7916 25.0004 16.8958 25.3546 16.8958H30.1254C30.9379 16.8958 31.6879 17.2499 32.2296 17.854C32.7712 18.479 33.0004 19.2709 32.8754 20.1251L32.2712 23.9583C32.1879 24.3125 32.4379 24.7501 32.7712 24.8543C33.0629 24.9584 33.5004 24.7915 33.6046 24.6249L38.5004 17.3541L41.1046 19.1042L36.2296 26.3751C35.4796 27.3751 34.1879 27.9999 32.9379 27.9999Z",
    fill: "url(#paint2_linear_505_6637)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4581 23.2501H42.2706C39.0206 23.2501 38.3331 21.1666 38.3331 19.4166V7.74995C38.3331 5.99995 39.0206 3.91669 42.2706 3.91669H43.4581C46.7081 3.91669 47.3956 5.99995 47.3956 7.74995V19.4166C47.3956 21.1666 46.7081 23.2501 43.4581 23.2501ZM41.5206 20.0417C41.5415 20.0417 41.7498 20.1251 42.2498 20.1251H43.4373C43.979 20.1251 44.1665 20.0416 44.2081 20.0208C44.2081 20 44.2706 19.8541 44.2706 19.4166V7.74995C44.2706 7.31245 44.2081 7.16677 44.1873 7.1251C44.2081 7.20844 43.979 7.04169 43.4581 7.04169H42.2706C41.729 7.04169 41.5415 7.12512 41.4998 7.14596C41.4998 7.16679 41.4373 7.31245 41.4373 7.74995V19.4166C41.4373 19.8541 41.4998 20 41.5206 20.0417Z",
    fill: "url(#paint3_linear_505_6637)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_505_6637",
    x1: 8.91622,
    y1: 33.4832,
    x2: 28.596,
    y2: 33.4832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_505_6637",
    x1: 2.62451,
    y1: 35.496,
    x2: 11.687,
    y2: 35.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_505_6637",
    x1: 21.3623,
    y1: 14.0927,
    x2: 41.1046,
    y2: 14.0927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_505_6637",
    x1: 38.3331,
    y1: 12.6627,
    x2: 47.3956,
    y2: 12.6627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B224EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7579FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDislike);
export default __webpack_public_path__ + "static/media/like-dislike.b4894df1a505045e9c6c5198b9962730.svg";
export { ForwardRef as ReactComponent };